<script setup>
import { reactiveOmit } from "@vueuse/core";
import { ScrollAreaCorner, ScrollAreaRoot, ScrollAreaViewport } from "reka-ui";
import { cn } from "@/lib/utils";
import ScrollBar from "./ScrollBar.vue";

const props = defineProps({
  type: { type: String, required: false },
  dir: { type: String, required: false },
  scrollHideDelay: { type: Number, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  id: { type: String, required: false },
});

const { id, ...rest } = reactiveOmit(props, "class");
</script>

<template>
  <ScrollAreaRoot
    v-bind="rest"
    :class="cn('vf-relative vf-overflow-hidden', props.class)"
  >
    <ScrollAreaViewport
      :id="id"
      class="vf-h-full vf-w-full vf-rounded-[inherit] focus:vf-outline-none focus-visible:vf-outline-none"
    >
      <slot />
    </ScrollAreaViewport>
    <ScrollBar />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
